// extracted by mini-css-extract-plugin
module.exports = {"timerContent":"CountDown_timerContent__2jnG7","time":"CountDown_time__zxnkw","text":"CountDown_text__2GdYT"};